import { create } from "zustand";
import { axiosHelper, tokenHelper } from "../helpers";
import { filterNonFalseValues } from "../helpers/Utlis";

export const useMenuStore = create((set, get) => ({
  menus: [],
  isLoading: false,
  isError: false,
  error: undefined,
  pagination: null,
  lastQuery: {
    siteId: null,
    page: 1,
    perPage: 50,
    search: "",
  },
  filters: {
    code: "",
    DestProv: "",
    dateFrom: "",
    dateTo: "",
    access: "",
    driverId: "",
    charger: false,
  },
  // Methods
  createMenu: async (body) => {
    set({ isLoading: true });

    try {
      // Get the access token
      const accessToken = await tokenHelper.getToken();

      // Post the site creation request
      const response = await axiosHelper.post("/menu/create", body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      //   // Link the site to the user
      //   await axiosHelper.patch(
      //     `/user/link-site?siteId=${response.site_id}`,
      //     { },
      //     { headers: { Authorization: `Bearer ${accessToken}` } }
      //   );

      //   // Refresh the list with last query params
      const { siteId, page, perPage, search } = get().lastQuery;
      await get().getMenus(siteId, page, perPage, search);
      return true;
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  bulkAddMenus: async (menus) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      const response = await axiosHelper.post(
        "/menu/bulk",
        { menus },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      const { siteId, page, perPage, search } = get().lastQuery;
      await get().getMenus(siteId, page, perPage, search);
      return response;
    } catch (e) {
      console.log(e);
      throw e;
    } finally {
      set({ isLoading: false });
    }
  },
  getMenus: async (siteId, page = 1, perPage = 50, search = "") => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });

      // Save query params for later use
      set({ lastQuery: { siteId, page, perPage, search } });

      const params = new URLSearchParams({ page, perPage });
      if (siteId) params.append("siteId", siteId);
      if (search && search.trim() !== "") params.append("search", search.trim());

      let response = await axiosHelper.get(
        `/menu/list/a?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      set({
        menus: response.menus,
        pagination: response.pagination,
        isLoading: false,
      });
      return response;
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },
  updateMenu: async (id, info) => {
    try {
      const accessToken = await tokenHelper.getToken();

      set({ isLoading: true });
      let response = await axiosHelper.patch(`/menu/${id}`, info, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      // Refresh with last query params
      const { siteId, page, perPage, search } = get().lastQuery;
      get().getMenus(siteId, page, perPage, search);
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },
  deleteMenu: async (menuId) => {
    try {
      set({ isLoading: true });
      const accessToken = await tokenHelper.getToken();

      let response = await axiosHelper.delete(`/menu/${menuId}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      // Refresh with last query params
      const { siteId, page, perPage, search } = get().lastQuery;
      get().getMenus(siteId, page, perPage, search);
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },
  reorderSiteMenus: async (siteId, orderedData) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      await axiosHelper.patch(`/menu/site/${siteId}/menus/reorder`, { menus: orderedData }, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const { siteId: lastSiteId, page, perPage, search } = get().lastQuery;
      await get().getMenus(lastSiteId, page, perPage, search);
      return true;
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  getSiteMenuFull: async (siteId) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      const response = await axiosHelper.get(`/menu/site/${siteId}/full`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      set({ isLoading: false });
      return response.data;
    } catch (e) {
      console.log(e);
      set({ isLoading: false });
      return null;
    }
  },
  saveSiteMenuStructure: async (siteId, data) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      await axiosHelper.patch(`/menu/site/${siteId}/structure`, data, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      set({ isLoading: false });
      return true;
    } catch (e) {
      console.log(e);
      set({ isLoading: false });
      return false;
    }
  },
  getSitesWithFullMenus: async () => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      const response = await axiosHelper.get(`/menu/sites/full`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      set({ isLoading: false });
      return response.data;
    } catch (e) {
      console.log(e);
      set({ isLoading: false });
      return null;
    }
  },
  setFilters: (filters) => {
    set({ filters: filterNonFalseValues(filters) });
  },
}));
